import { ContentCopy } from "@mui/icons-material";
import { Button, Stack, SxProps, Theme, useTheme } from "@mui/material";
import { useState } from "react";
import { AlertSnackbar } from "./Snackbar";

type Props = {
  children: React.ReactNode;
  text?: string;
  sx?: SxProps<Theme>;
};

export function CopyButton({ children, text, sx }: Props) {
  const theme = useTheme();
  const [showAlert, setShowAlert] = useState(false);
  return (
    <Stack
      direction={"row"}
      gap={1}
      justifyContent={"flex-start"}
      alignItems={"center"}
      sx={sx}
    >
      {children}
      {text && (
        <Button
          sx={{ p: 0.25, m: 0, minWidth: 0, color: theme.palette.grey[600] }}
          onClick={() => {
            navigator.clipboard.writeText(text);
            setShowAlert(true);
          }}
        >
          <ContentCopy fontSize="small" />
        </Button>
      )}
      <AlertSnackbar severity="success" onClose={() => setShowAlert(false)}>
        {showAlert ? `Copied ${text}` : null}
      </AlertSnackbar>
    </Stack>
  );
}
